export const REQUEST_INDUSTRY_RESEARCH_MODULE = "REQUEST_INDUSTRY_RESEARCH_MODULE";
export const FINISH_REQUEST_INDUSTRY_RESEARCH_MODULE = "FINISH_REQUEST_INDUSTRY_RESEARCH_MODULE";
export const RECEIVE_INDUSTRY_RESEARCH_MODULE_DATA = "RECEIVE_INDUSTRY_RESEARCH_MODULE_DATA";
